import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getActiveTab,
  getResultState,
  getSettingsState,
  getUIState,
} from '../../store/slices/selectors'
import { uiActions } from '../../store/slices'

import { LoadingIndicator, StatusSection, Tabs } from '../../../../components'
import { Result } from './components'

import { LOADING } from '../../../../utils/constants'
import { RenderAorB } from '../../../../utils/fns'

import { warningText } from '../../common/json/common.json'

const Output = (props) => {
  const dispatch = useDispatch()
  const activeTab = useSelector(getActiveTab)
  const { loading, error, data } = useSelector(getResultState)
  const { inputErrors, inputWarning } = useSelector(getUIState)
  const country = useSelector((state) => getSettingsState(state).country)

  return (
    <div className="outputSectionWrapper" {...props}>
      <Tabs
        activeTab={activeTab}
        setActiveTab={(tab) => dispatch(uiActions.setActiveTab(tab))}
        className="paneHeader"
      >
        <div
          eventKey="output"
          title={<div className="paneHeader__staticHeading">Output</div>}
          className="outputSection"
        >
          <div className="container-fluid space-y-12">
            {RenderAorB(
              loading === LOADING.FAILED,
              <StatusSection
                statusLevel="error"
                statusIcon="error"
                statusHeader="Network Error"
                statusBody={error}
              />,
              RenderAorB(
                loading === LOADING.PENDING,
                <LoadingIndicator />,
                RenderAorB(
                  inputErrors,
                  <StatusSection
                    statusLevel="error"
                    statusIcon="error"
                    statusHeader="Validation"
                    statusBody={inputErrors}
                  />,
                  <Fragment>
                    {RenderAorB(
                      inputWarning,
                      <StatusSection
                        statusLevel="warning"
                        statusIcon="assets/images/icons/sst-icon-info.svg"
                        statusHeader="Warning"
                        statusBody={warningText.multipleLoadDirections[country]}
                      />,
                    )}
                    {RenderAorB(
                      !data || data.length === 0,
                      <StatusSection
                        statusLevel="warning -noResults"
                        statusIcon="assets/images/icons/sst-icon-info.svg"
                        statusHeader="No Output Results"
                        statusBody="There are no results based upon the input parameters. Try editing your input criteria, or use the reset button to load the initial conditions."
                      />,
                      <Result />,
                    )}
                  </Fragment>,
                ),
              ),
            )}
          </div>
        </div>
      </Tabs>
    </div>
  )
}

export default Output
